export default "__VITE_ASSET__BCJrLywV__"